import type { PriceRoundingMode } from "./services/catalog";

/**
 * What the tier forms (New, Detail) say about rounding and purchase types — one copy, so the two
 * forms cannot drift (2026-09-29: the owner found the tier screens hard to understand).
 *
 * The rounding examples are fixed text, not a computation: rounding is the API's (constitution I,
 * pricing-admin.md "discount → Rounding.Rate (2 dp) → the tier's priceRoundingMode, in that order").
 * They only show what each mode does to one sample rate.
 */
export const ROUNDING_MODES: readonly PriceRoundingMode[] = ["none", "rupee", "nearest_5"];

export const ROUNDING_LABEL: Record<PriceRoundingMode, string> = {
  none: "No rounding — ₹1,232.37 stays ₹1,232.37",
  rupee: "Nearest rupee — ₹1,232.37 becomes ₹1,232",
  nearest_5: "Nearest ₹5 — ₹1,232.37 becomes ₹1,230",
};

/** The mode's plain name, for a sentence ("then applies this tier's rounding (nearest rupee)"). */
export const ROUNDING_NAME: Record<PriceRoundingMode, string> = {
  none: "no rounding",
  rupee: "nearest rupee",
  nearest_5: "nearest ₹5",
};

export const ROUNDING_HINT =
  "Applied to each price after the discount, once it has been rounded to paise. Base prices are never rounded by a tier.";

/** D-02: a "piece" is the Piece (PCS) unit; a "unit" purchase is any other unit — by weight, length or area. */
export const PIECE_PURCHASE = {
  label: "Allow piece purchase",
  helperText: "Customers on this tier can buy by the piece — the Piece (PCS) unit.",
};
export const FOR_NEW_COMPANIES = {
  label: "Assign to new company registrations",
  helperText:
    "A company that registers starts on this tier — B2B, with no credit limit until you assign one. Only one tier can be marked; marking this one unmarks the other.",
};
export const UNIT_PURCHASE = {
  label: "Allow unit purchase",
  helperText: "Customers on this tier can buy by weight, length or area — KGS, metres, square feet.",
};
